/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_ManualInputs */



/**
* | output |
* | --- |
* | "Manual" |
*
* @param {Segment_Event_Group_ManualInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_manual = /** @type {((inputs?: Segment_Event_Group_ManualInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_ManualInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Manuelle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Handbuch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Manuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Руководство")
	if (locale === "es") return /** @type {LocalizedString} */ ("Manual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("手动的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マニュアル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नियमावली")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Manual")
	return /** @type {LocalizedString} */ ("Manual")
});